import React from 'react'
import AppPieChart from './charts/AppPieChart';
import AppDoughnutChart from './charts/AppDoughnutChart';

function GroupPendencyChart({supervisorList}) {

    const dataLabels = [];
    const chartData = [];

    supervisorList.forEach(supervisor=>{
        dataLabels.push(supervisor.firstName+ " "+supervisor.lastName + " ("+supervisor.grievanceList.length+")");
        chartData.push(supervisor.grievanceList.length);
    })

  return (
        <AppPieChart dataLabels={dataLabels} chartData={chartData} />
  )
}

export default GroupPendencyChart